import React, { useState, useEffect } from "react";
import { getStudentIdData } from "../../../../lib/studentmainessay";

export default function MainEssayForProfile({ slug }) {
  const [mainEssaydb, setMainEssayDb] = useState([]);
  const [prompt, setPrompt] = useState("");
  const [fiveAdjectives, setFiveAdjectives] = useState("");
  const [instructorComment, setInstructorComment] = useState("");
  const [studentComment, setStudentComment] = useState("");
  const [mainEssay, setMainEssay] = useState("");
  // console.log("slug Main Essay : ", slug);

  async function getDatafromMainEssay() {
    const mainEssayfromdb = await getStudentIdData(slug);
    console.log("Main Essay From Db : ", mainEssayfromdb);
    if( mainEssayfromdb[0]) {
    setPrompt(mainEssayfromdb[0].prompt);
    setInstructorComment(mainEssayfromdb[0].instructorComment);
    setFiveAdjectives(mainEssayfromdb[0].fiveAdjectives);
    setStudentComment(mainEssayfromdb[0].studentComment);
    setMainEssay(mainEssayfromdb[0].mainEssay);
    setMainEssayDb(mainEssayfromdb);
    }
  }

  useEffect(() => {
    getDatafromMainEssay();
  }, [setMainEssayDb]);

  return (
    <div className="card-body">
      <div className="row">
        <div className="col-md-12">
          <h4 className="goal_settings_title">Main College Essay</h4>
          <div className="wishlist-item mt-5">
            { mainEssaydb[0] ?
            <div style={{ color: "black", backgroundColor: "white" }}>
              <div className="mb-3">
                <label className="form-label fw-bold">Prompt:</label>
                <div>{prompt}</div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Five Adjectives:</label>
                <div>{fiveAdjectives}</div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">
                  Instructor Comment:
                </label>
                <div>{instructorComment}</div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Student Comment:</label>
                <div>{studentComment}</div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">
                  Main College Essay:
                </label>
                <div
                  style={{ lineHeight: "1.6", marginTop: "10px" }}
                  dangerouslySetInnerHTML={{ __html: mainEssay }}
                />
              </div>
              {/* <div className="mb-3">
        <label className="form-label fw-bold">Main College Essay:</label>
        <div style={{ lineHeight: "1.6", marginTop: "10px" }}>
          {mainEssay.split("\n").map((paragraph, index) => (
            <div key={index} style={{ marginBottom: "15px" }}>
              {paragraph}
            </div>
          ))}
        </div> 
      </div> */}
            </div>
: "No Main Essay"}
          </div>
        </div>
      </div>
    </div>
  );
}
